import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * OIDC redirect target registered on the Logto SPA application:
 *   https://vnmade.xbuyer.com/auth/callback
 *
 * It is deliberately OUTSIDE <RequireSession>: the whole point of this page is
 * that there is no session yet. It consumes the authorization code, exchanges
 * it for an org-scoped access token, then navigates back to the deep link that
 * triggered sign-in.
 */
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSession } from "../lib/SessionContext.js";
import { Page, Card, Notice, Pill } from "../components/ui.js";
export function AuthCallbackPage() {
    const { completeOidcSignIn } = useSession();
    const navigate = useNavigate();
    const [err, setErr] = useState(null);
    // Guard against React StrictMode's double effect invocation: an authorization
    // code is single-use, so it must never be exchanged twice.
    const once = useRef(false);
    useEffect(() => {
        if (once.current)
            return;
        once.current = true;
        let live = true;
        void completeOidcSignIn(window.location.search)
            .then((from) => {
            if (live)
                navigate(from, { replace: true });
        })
            .catch((e) => {
            if (live)
                setErr(e instanceof Error ? e.message : String(e));
        });
        return () => {
            live = false;
        };
    }, [completeOidcSignIn, navigate]);
    return (_jsx(Page, { title: "\u6B63\u5728\u5B8C\u6210\u767B\u5F55", titleEn: "Signing in", subtitle: "\u6821\u9A8C state\u3001\u4EA4\u6362\u6388\u6743\u7801\u5E76\u83B7\u53D6\u7EC4\u7EC7\u4EE4\u724C", meta: _jsx(Pill, { tone: "info", children: "Logto OIDC" }), children: _jsx(Card, { title: "\u4F1A\u8BDD\u4EA4\u6362", children: err ? (_jsxs("div", { className: "stack", children: [_jsx(Notice, { tone: "error", children: err }), _jsx("div", { className: "row", children: _jsx(Link, { className: "btn btn--primary", to: "/login", children: "\u8FD4\u56DE\u767B\u5F55\u9875\u91CD\u8BD5" }) })] })) : (_jsx(Notice, { children: "\u6B63\u5728\u7528 authorization code + PKCE verifier \u6362\u53D6 refresh_token\uFF0C\u518D\u6362\u53D6\u5E26 organization_id \u4E0E scope \u7684 org access token\u2026" })) }) }));
}
